/* eslint-disable no-restricted-imports */
import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import * as actions from "../../../_redux/schJobInfos/schJobInfosActions";
import { useSchJobInfosUIContext } from "../SchJobInfosUIContext";

export function SchJobInfoDeleteDialog({ id, show, onHide }) {
  // SchJobInfos UI Context
  const schJobInfosUIContext = useSchJobInfosUIContext();
  const schJobInfosUIProps = useMemo(() => {
    return {
      setIds: schJobInfosUIContext.setIds,
      queryParams: schJobInfosUIContext.queryParams,
    };
  }, [schJobInfosUIContext]);

  // SchJobInfos Redux state
  const dispatch = useDispatch();
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.schJobInfos.actionsLoading }),
    shallowEqual
  );

  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // looking for loading/dispatch
  useEffect(() => {}, [isLoading, dispatch]);

  const deleteSchJobInfo = () => {
    // server request for deleting schJobInfo by id
    dispatch(actions.deleteSchJobInfo(id)).then(() => {
      // refresh list after deletion
      dispatch(actions.fetchSchJobInfos(schJobInfosUIProps.queryParams));
      // clear selections list
      schJobInfosUIProps.setIds([]);
      // closing delete modal
      onHide();
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {isLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          SchJobInfo Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!isLoading && (
          <span>Are you sure to permanently delete this schJobInfo?</span>
        )}
        {isLoading && <span>SchJobInfo is deleting...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={deleteSchJobInfo}
            className="btn btn-delete btn-elevate"
          >
            Delete
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
